import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { SettingsSection } from "@/components/settings/sections/SettingsSection";
import { ConfigurationSection } from "@/components/settings/sections/ConfigurationSection";
import { FeatureFlagsSection } from "@/components/settings/sections/FeatureFlagsSection";

export function SettingsPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Settings
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Presentation only — nothing here can be edited or persisted.
        </Typography>
      </Box>
      <Stack spacing={3}>
        <SettingsSection />
        <ConfigurationSection />
        <FeatureFlagsSection />
      </Stack>
    </ResponsiveContainer>
  );
}
